export default __webpack_public_path__ + "c8ebf162899ed4bb81a04942148e13a0.png";